import AssignmentsScreen from "./AssignmentsScreen";


export default AssignmentsScreen;